
import '../../../../assets/css/screens/serviceprovider/dashboard/helpandsupport/HelpAndSupport.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../../../../context/AppContext';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useParams } from "react-router-dom";
import {
  ArrowLeft, Clock, CheckCircle, AlertCircle,
  MessageSquare, Headphones, ChevronRight, ShieldAlert
} from 'lucide-react';

/* ── Dummy tickets ── */


const STATUS_CFG = {
  pending: { label: 'Pending', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', icon: <Clock size={13} /> },
  // open:        { label:'Open',        color:'#0491e1', bg:'rgba(4,145,225,0.12)',   icon:<AlertCircle size={13}/> },
  in_progress: { label: 'In Progress', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)', icon: <Clock size={13} /> },
  resolved: { label: 'Resolved', color: '#10b981', bg: 'rgba(16,185,129,0.12)', icon: <CheckCircle size={13} /> },
};


const WorkerHelpSupport = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('all');
  const [conversationId, setConversationId] = useState();
  const [messages, setMessages] = useState([]);

  const FILTERS = ['all', 'pending', 'in_progress', 'resolved'];
  
  const viewtikets = async () => {
    const authToken = localStorage.getItem('authToken');
    axios.get(`${baseUrl}/worker/viewtickets`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
 .then((response) => {
  console.log("FULL RESPONSE:", response.data);
  console.log("TICKETS:", response.data.supporttickets);

  setTickets(response.data.supporttickets || []);
})
      .catch((error) => {
        console.log(error);
      });
  }
  

  const filtered = filter === 'all'
    ? tickets
    : tickets.filter(t => t.status === filter);
  useEffect(() => {
    viewtikets();
  }, []);



  return (
    <>
      <WorkerNavbar />
      <div className="whs-page">

        {/* ── Header ── */}
        <div className="whs-header">
          <button className="whs-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <div className="whs-header__info">
            <h2 className="whs-title">Help &amp; Support</h2>
            <span className="whs-title-sub">Your support tickets</span>
          </div>
          <div className="whs-header__icon">
            <Headphones size={22} />
          </div>
        </div>

        <div className="whs-body">

          {/* ── Filter tabs ── */}
          <div className="whs-filters">
            {FILTERS.map(f => (
              <button
                key={f}
                className={'whs-filter-btn' + (filter === f ? ' whs-filter-btn--active' : '')}
                onClick={() => setFilter(f)}
              >
                {f === 'all' ? 'All' : STATUS_CFG[f]?.label || f}
                {f !== 'all' && (
                  <span className="whs-filter-count">
                    {tickets.filter(t => t.status === f).length}
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* ── Ticket List ── */}
          {loading ? (
            <div className="whs-loading">
              <span className="whs-spinner" />
              Loading tickets...
            </div>
          ) : filtered.length === 0 ? (
            <div className="whs-empty">
              <div className="whs-empty__icon"><ShieldAlert size={36} /></div>
              <p className="whs-empty__text">No tickets found</p>
              <span className="whs-empty__sub">No support tickets in this category</span>
            </div>
          ) : (
            <div className="whs-tickets-list">
              {filtered.map((t, i) => {
                const st = STATUS_CFG[t.status] || STATUS_CFG.pending;
                const msgCount = t.whconversations?.length || 0;
                const convId = t.whconversations?.[0]?.id;
                return (
                  <div
                    key={t.id}
                    className="whs-ticket-card"
                    style={{ animationDelay: i * 0.07 + 's' }}
                  >
                    {/* Top row */}
                    <div className="whs-ticket-card__top">
                      <div className="whs-ticket-card__left">
                        <div className="whs-ticket-card__cat-icon">
                          <Headphones size={16} />
                        </div>
                        <div>
                          <h5 className="whs-ticket-card__title">{t.category}</h5>
                          <div className="whs-ticket-card__tags">
                            <span className="whs-tag whs-tag--raised">By: {t.raisedby}</span>
                            <span className="whs-tag whs-tag--against">vs: {t.against}</span>
                          </div>
                        </div>
                      </div>
                      <span
                        className="whs-ticket-card__status"
                        style={{ color: st.color, background: st.bg }}
                      >
                        {st.icon} {st.label}
                      </span>
                    </div>

                    {/* Description */}
                    {t.description && (
                      <p className="whs-ticket-card__desc">{t.description}</p>
                    )}

                    {/* Footer */}
                    <div className="whs-ticket-card__footer">
                      <span className="whs-ticket-card__msgs">
                        <MessageSquare size={13} />
                        {msgCount} message{msgCount !== 1 ? 's' : ''}
                      </span>
                      <button
                        className="hs-ticket-card__chat-btn"
                        onClick={() =>
                          navigate(`/worker-chat/${t.whconversations?.[0]?.id}`)
                        }
                      >
                        <MessageSquare size={14} /> Open Chat
                        <ChevronRight size={14} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default WorkerHelpSupport;

